import React, { useEffect, useState } from 'react';
import {
  FaShoppingCart,
  FaCode,
  FaGlobe,
  FaShareAlt,
  FaSearch,
  FaBullhorn,
  FaArrowRight
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.querySelector('.services-grid');
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  const services = [
    {
      icon: <FaShoppingCart />,
      title: 'E-commerce Development',
      subtitle: 'Shopify & Custom Solutions',
      description:
        'Complete e-commerce solutions with premium themes, payment gateways, and inventory management for online retail success.',
      features: [
        'Custom Shopify Stores',
        'Payment Integration',
        'Inventory Management',
        'Mobile Responsive'
      ],
      popular: true
    },
    {
      icon: <FaCode />,
      title: 'Website Development',
      subtitle: 'Custom Web Applications',
      description:
        'Professional website development using modern technologies to create fast, secure, and scalable web applications.',
      features: [
        'Custom Development',
        'CMS Integration',
        'API Development',
        'Database Design'
      ]
    },
    {
      icon: <FaGlobe />,
      title: 'Web Design',
      subtitle: 'UI/UX & Branding',
      description:
        'Creative web design services that combine aesthetics with functionality to deliver exceptional user experiences.',
      features: ['UI/UX Design', 'Responsive Design', 'Brand Identity', 'Prototyping']
    },
    {
      icon: <FaShareAlt />,
      title: 'Social Media Management',
      subtitle: 'Digital Presence',
      description:
        'Strategic social media management to build your brand presence and engage with your target audience effectively.',
      features: [
        'Content Strategy',
        'Social Media Posts',
        'Community Management',
        'Analytics'
      ]
    },
    {
      icon: <FaSearch />,
      title: 'Search Engine Optimization',
      subtitle: 'SEO & Digital Marketing',
      description:
        'Comprehensive SEO strategies to improve your website ranking and increase organic traffic from search engines.',
      features: ['On-Page SEO', 'Technical SEO', 'Content Optimization', 'Performance Tracking']
    },
    {
      icon: <FaBullhorn />,
      title: 'Digital Marketing',
      subtitle: 'Paid Advertising',
      description:
        'Strategic digital marketing campaigns across multiple platforms to maximize your ROI and business growth.',
      features: ['Google Ads', 'Facebook Ads', 'Email Marketing', 'Analytics']
    }
  ];

  return (
    <section className="services-section section" id="services">
      <div className="container">
        <div className="section-title">
          <span className="section-subtitle">What We Offer</span>
          <h2>Our Digital Solutions & Services</h2>
          <p>
            Comprehensive digital services designed to transform your business and
            accelerate your growth in the competitive digital marketplace.
          </p>
        </div>

        <div className={`services-grid ${isVisible ? 'visible' : ''}`}>
          {services.map((service, index) => (
            <div
              key={index}
              className={`service-card ${service.popular ? 'popular' : ''}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {service.popular && <div className="popular-badge">Most Popular</div>}

              <div className="service-icon">{service.icon}</div>

              <div className="service-content">
                <h3>{service.title}</h3>
                <p className="service-subtitle">{service.subtitle}</p>
                <p className="service-description">{service.description}</p>

                <ul className="service-features">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex}>{feature}</li>
                  ))}
                </ul>

                <Link to="/contact" className="service-link">
                  Learn More
                  <FaArrowRight className="service-link-icon" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="services-cta">
          <div className="cta-content">
            <h3>Need a Custom Solution?</h3>
            <p>
              Don't see exactly what you're looking for? We specialize in creating
              custom digital solutions tailored to your specific business needs.
            </p>
            <Link to="/contact" className="btn btn-primary">
              Discuss Your Project
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
